// Function to truncate the name if it's too long to 20 characters
export const truncateName = (name: string) => {
  if (name?.length > 20) {
    return name.slice(0, 20) + "...";
  } else {
    return name;
  }
};
